<template>

    <div class="salesLead-notice-container">
        <div class="header-row">
            <span class="heading">{{ $t("lbl_EMPBE_SalesLead_HomeUnread") }}</span>
            <router-link :to="{ path: '/salesLead/all' }" custom v-slot="{ navigate }">
                <a
                    href="javascript:void(0)"
                    @click="isDisabled ? undefined : navigate($event)"
                    class="all-link"
                    v-bind:t_label="'EMP3_SalesLead_Home_Navigate_All_0'"
                >
                    <span class="all-text">{{ $t("lbl_EMPBE_SalesLead_Tab_All") }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <g clip-path="url(#clip0_sl_all)">
                            <path
                                d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                                fill="currentColor" />
                        </g>
                        <defs>
                            <clipPath id="clip0_sl_all">
                                <rect width="20" height="20" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </a>
            </router-link>
        </div>

        <!-- Direct Enquiries -->
        <router-link :to="{ path: '/salesLead/default' }" custom v-slot="{ navigate }">
            <a
                href="javascript:void(0)"
                @click="isDisabled ? undefined : navigate($event)"
                class="button-container"
                v-bind:t_label="'EMP3_SalesLead_Home_Navigate_DirectEnquiries_0'"
            >
                <i>
                    <img
                        :src="typeIconSrc('Enquiry', UnreadEnquiry)"
                        alt="Direct Enquiries"
                        width="24"
                        height="24"
                    />
                </i>
                <div class="title">
                    <div class="title_Nav">
                        <div class="inner">
                            {{ $t("lbl_EMPBE_SalesLead_DirectEnquiries") }}
                        </div>
                        <div class="FreeTips" v-if="IsFreeBooth && YearRemainingQuotaEnquiry > 0">{{ $t('lbl_EMPBE_SalesLeadFreeQuota', {
                            remainingCredit:
                            YearRemainingQuotaEnquiry}) }}</div>
                    </div>
                    <div class="number" v-if="UnreadEnquiry > 0">{{ UnreadEnquiry }}</div>
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_1415_1892)">
                                <path
                                    d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                                    fill="black" fill-opacity="0.8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1415_1892">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </i>
                </div>

            </a>
        </router-link>
        
        <!-- Name Card entrance -->
        <router-link :to="{ path: '/salesLead/nameCard' }" custom v-slot="{ navigate }">
            <a
                href="javascript:void(0)"
                @click="isDisabled ? undefined : navigate($event)"
                class="button-container"
                v-bind:t_label="'EMP3_SalesLead_Home_Navigate_NameCard_2'"
            >
                <i>
                    <img
                        :src="typeIconSrc('id_card_small', UnreadNameCard)"
                        alt="Name Card"
                        width="24"
                        height="24"
                    />
                </i>
                <div class="title">
                    <div class="title_Nav">
                        <div class="inner">
                            {{ $t("lbl_EMPBE_SalesLead_NameCard") }}
                        </div>
                        <div class="FreeTips" v-if="IsFreeBooth && YearRemainingQuotaNameCard > 0">{{ $t('lbl_EMPBE_SalesLeadFreeQuota', {
                            remainingCredit:
                            YearRemainingQuotaNameCard}) }}</div>
                    </div>
                    <div class="number" v-if="UnreadNameCard > 0">{{ UnreadNameCard }}</div>
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_1415_1892)">
                                <path
                                    d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                                    fill="black" fill-opacity="0.8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1415_1892">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </i>
                </div>
            </a>
        </router-link>

        <!-- Like / Follow entrance -->
        <router-link :to="{ path: '/salesLead/likeFollow' }" custom v-slot="{ navigate }">
            <a
                href="javascript:void(0)"
                @click="isDisabled ? undefined : navigate($event)"
                class="button-container"
                v-bind:t_label="'EMP3_SalesLead_Home_Navigate_LikeFollow_3'"
            >
                <i>
                    <img
                        :src="typeIconSrc('favorite', UnreadLikeFollow)"
                        alt="Like/Follow"
                        width="24"
                        height="24"
                    />
                </i>
                <div class="title">
                    <div class="title_Nav">
                        <div class="inner">
                            {{ $t("lbl_EMPBE_SalesLead_LikeFollow") }}
                        </div>
                        <div class="FreeTips" v-if="IsFreeBooth && YearRemainingQuotaLikeFollow > 0">{{ $t('lbl_EMPBE_SalesLeadFreeQuota', {
                            remainingCredit: YearRemainingQuotaLikeFollow
                        }) }}</div>
                    </div>
                    <div class="number" v-if="UnreadLikeFollow > 0">{{ UnreadLikeFollow }}</div>
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_1415_1892)">
                                <path
                                    d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                                    fill="black" fill-opacity="0.8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1415_1892">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </i>
                </div>
            </a>
        </router-link>

        <router-link :to=" { path: '/salesLead/SourcingRequestMatched' }" custom v-slot="{ navigate }">
            <a
                href="javascript:void(0)"
                @click="isDisabled ? undefined : navigate($event)"
                class="button-container"
                v-bind:t_label="'EMP3_SalesLead_Home_Navigate_SourcingRequestMatched_1'"
            >
                <i>
                    <img
                        :src="typeIconSrc('Post_match', UnreadSourcingRequests)"
                        alt="Sourcing Requests Matched"
                        width="24"
                        height="24"
                    />
                </i>
                <div class="title">
                    <div class="title_Nav">
                        <div class="inner">
                            {{ $t("lbl_EMPBE_SalesLead_SourcingMathedTitle") }}
                        </div>
                    </div>
                    <div class="number" v-if="UnreadSourcingRequests > 0">{{ UnreadSourcingRequests }}</div>
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_1415_1892)">
                                <path
                                    d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                                    fill="black" fill-opacity="0.8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1415_1892">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </i>
                </div>
            </a>
        </router-link>
        <router-link :to="{ path: '/salesLead/SourcingRequestApplied' }" custom v-slot="{ navigate }">
            <a
                href="javascript:void(0)"
                @click="isDisabled ? undefined : navigate($event)"
                class="button-container"
                v-bind:t_label="'EMP3_SalesLead_Home_Navigate_SourcingRequestApplied_1'"
            >
                <i>
                    <img
                        :src="typeIconSrc('Post_reply', UnreadSourcingContactBuyer)"
                        alt="Your Approved Applications"
                        width="24"
                        height="24"
                    />
                </i>
                <div class="title">
                    <span class="inner">
                        {{ $t("lbl_EMPBE_SalesLead_YourApprovedReplies") }}
                    </span>
                    <div class="number" v-if="UnreadSourcingContactBuyer > 0">{{ UnreadSourcingContactBuyer }}</div>
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_1415_1892)">
                                <path
                                    d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                                    fill="black" fill-opacity="0.8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1415_1892">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </i>
                </div>

            </a>
        </router-link>

    </div>

</template>
<script>
const SL_NEWICON_CDN = 'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Newicon/';

export default {
    props: {
        UnreadEnquiry: Number,
        UnreadNameCard: {
            type: Number,
            default: 0
        },
        UnreadLikeFollow: {
            type: Number,
            default: 0
        },
        UnreadSourcingRequests: Number,
        UnreadSourcingContactBuyer: Number,
        isDisabled: {
            type: Boolean,
            default: false
        },
        IsFreeBooth: Boolean,
        YearRemainingQuotaEnquiry: Number,
        YearRemainingQuotaNameCard: Number,
        YearRemainingQuotaLikeFollow: Number,
        YearRemainingQuotaSourcingRequest: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        /** 有未读用蓝色 _Select，无未读用灰色默认图 */
        typeIconSrc(baseName, unreadCount) {
            const selected = Number(unreadCount) > 0 ? '_Select' : '';
            return `${SL_NEWICON_CDN}${baseName}${selected}.svg`;
        },
    },
}
</script>
<style lang="scss" scoped>
.salesLead-notice-container {
    display: flex;
    padding: 24px;
    flex-direction: column;

    gap: 16px;
    border-radius: 16px;
    background: #FFF;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);

    .header-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        width: 100%;
        gap: 8px;
    }

    .heading {
        flex: 1 1 auto;
        min-width: 0;
        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 16px;
        font-family: Roboto;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.15px;
    }

    .all-link {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        flex-shrink: 0;
        text-decoration: none;
        letter-spacing: normal;
        color: var(--on-surface-60, rgba(0, 0, 0, 0.60));

        &:hover,
        &:focus,
        &:active {
            text-decoration: none;
        }

        .all-text {
            margin-top: 1px;
            color: var(--on-surface-60, rgba(0, 0, 0, 0.60));
            font-size: 14px;
            font-family: Inter, Roboto, sans-serif;
            font-weight: 600;
            line-height: 14px;
            text-box-trim: trim-both;
            text-box-edge: cap alphabetic;
            white-space: nowrap;
        }

        svg {
            flex-shrink: 0;
            display: block;
            width: 20px;
            height: 20px;
        }
    }

    .button-container {
        display: flex;
        padding: 8px 16px;
        text-decoration: none;
        justify-content: flex-start;
        align-items: center;
        gap: 12px;
        align-self: stretch;
        border-radius: 8px;
        border: 1px solid var(--outline-10, rgba(0, 0, 0, 0.10));
        background: var(--Surface, #FFF);

        &:hover,
        &:focus,
        &:active {
            text-decoration: none;
        }

        /* 左侧类型图标：固定靠左，不随文案/额度换行偏移 */
        > i {
            display: flex;
            flex: 0 0 24px;
            width: 24px;
            height: 24px;
            padding: 0;
            justify-content: center;
            align-items: center;
            align-self: center;

            img {
                display: block;
                width: 24px;
                height: 24px;
            }
        }

        .title {
            display: flex;
            align-items: center;
            gap: 12px;
            flex: 1 1 auto;
            min-width: 0;

            .title_Nav {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                gap: 2px;
                flex: 1 1 auto;
                min-width: 0;

                .inner {
                    display: block;
                    flex: 0 1 auto;
                    max-width: 100%;
                    min-width: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            .inner {
                display: block;
                flex: 1 1 auto;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: 150%;
                letter-spacing: -0.154px;
            }

            .number {
                display: flex;
                min-width: 20px;
                max-width: 42.5px;
                flex-shrink: 0;
                padding: 0px 5px;
                justify-content: center;
                align-items: center;
                border-radius: 125px;
                background: var(--primary-supplier-backend, #7366FF);
                color: var(--M3-sys-light-on-error, #FFF);
                text-align: center;
                font-family: Roboto;
                font-size: 13.75px;
                font-style: normal;
                font-weight: 700;
                line-height: 20px;
            }

            .FreeTips {
                color: #000;
                font-feature-settings: 'liga' off, 'clig' off;
                font-size: 12px;
                font-style: normal;
                font-weight: 700;
                line-height: 150%;
                display: inline-flex;
                padding: var(--2, 2px) var(--8, 8px);
                align-items: center;
                border-radius: var(--4, 4px);
                background: #E7F8FF;
                max-width: 100%;
            }

            > i {
                width: 20px;
                height: 20px;
                flex-shrink: 0;
            }
        }
    }


}
</style>